import { render, staticRenderFns } from "./WorkflowEditor.vue?vue&type=template&id=2e11ffc6"
import script from "./WorkflowEditor.vue?vue&type=script&lang=js"
export * from "./WorkflowEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports